import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AddTransferFormSet = ({
    setCount,
    setDescription,
    setAddProcess,
    setSetCount,
    setSetDescription,
    handleAddSetTransfer,
    handleCancelSetTransfer,
}: any) => {
    const { t } = useTranslation(['Warehouses', 'common']);

    return (
        <Form
            onSubmit={(e) => {
                e.preventDefault();
                handleAddSetTransfer();
            }}
        >
            <Form.Group className="mb-3">
                <label className="form-label text-muted">{t('labelCount')}</label>
                <input
                    className="form-control"
                    required
                    type="number"
                    min={1}
                    step={1}
                    value={setCount}
                    disabled={setAddProcess}
                    onChange={(e) => setSetCount(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <label className="form-label text-muted">{t('labelDescription')}</label>
                <Form.Control
                    as="textarea"
                    rows={4}
                    value={setDescription}
                    disabled={setAddProcess}
                    onChange={(e) => setSetDescription(e.target.value)}
                />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
                <Button
                    size="sm"
                    variant="light"
                    type="button"
                    disabled={setAddProcess}
                    onClick={handleCancelSetTransfer}
                >
                    {t('buttons.cancel', { ns: 'common' })}
                </Button>
                <Button size="sm" variant="primary" type="submit" disabled={setAddProcess}>
                    <i className="bi bi-plus-lg me-1 fs-14"></i>
                    {t('btnAdd')}
                </Button>
            </div>
        </Form>
    );
};

export default AddTransferFormSet;
